import React from 'react';
import { useLanguage } from '../context/LanguageContext';
import { Users, Monitor, Wrench, Target, Code, Cpu } from 'lucide-react';

const About = () => {
  const { t } = useLanguage();

  const icons = [Users, Monitor, Wrench, Target];

  return (
    <section id="about" className="py-24 bg-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-16 items-center">
          {/* Left Content */}
          <div>
            <span className="inline-block px-4 py-1.5 bg-sky-100 text-sky-600 text-sm font-medium rounded-full mb-4">
              {t.about.title}
            </span>
            <h2 className="text-3xl sm:text-4xl font-bold text-slate-800 mb-6">
              {t.about.subtitle}
            </h2>
            <p className="text-lg text-slate-600 leading-relaxed mb-8">
              {t.about.description}
            </p>

            {/* Features Grid */}
            <div className="grid sm:grid-cols-2 gap-6">
              {t.about.features.map((feature, index) => {
                const Icon = icons[index];
                return (
                  <div
                    key={index}
                    className="group p-5 rounded-2xl bg-slate-50 hover:bg-gradient-to-br hover:from-sky-50 hover:to-cyan-50 transition-all duration-300 hover:shadow-lg"
                  >
                    <div className="w-12 h-12 bg-white rounded-xl shadow-sm flex items-center justify-center mb-4 group-hover:shadow-md transition-shadow">
                      <Icon className="w-6 h-6 text-sky-500" />
                    </div>
                    <h3 className="font-semibold text-slate-800 mb-1">{feature.title}</h3>
                    <p className="text-sm text-slate-500">{feature.desc}</p>
                  </div>
                );
              })}
            </div>
          </div>

          {/* Right Visual */}
          <div className="relative">
            {/* Animated Cards Stack */}
            <div className="relative h-[400px]">
              
              {/* Card 1 - Robotics */}
              <div className="absolute top-0 left-0 w-48 h-56 bg-gradient-to-br from-cyan-500 to-blue-600 rounded-3xl shadow-2xl p-5 transform rotate-[-8deg] hover:rotate-0 transition-all duration-500 hover:scale-105 cursor-pointer z-10">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                  <Cpu className="w-6 h-6 text-white" />
                </div>
                <h4 className="text-white font-bold text-lg mb-1">Robottexnika</h4>
                <p className="text-white/70 text-xs">Arduino & Automation</p>
                <div className="absolute bottom-4 right-4 w-16 h-16 bg-white/10 rounded-full"></div>
              </div>
          
              {/* Card 2 - Web Development */}
              <div className="absolute top-12 right-0 w-48 h-56 bg-gradient-to-br from-sky-400 to-cyan-500 rounded-3xl shadow-2xl p-5 transform rotate-[6deg] hover:rotate-0 transition-all duration-500 hover:scale-105 cursor-pointer z-20">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                  <Code className="w-6 h-6 text-white" />
                </div>
                <h4 className="text-white font-bold text-lg mb-1">Web Dev</h4>
                <p className="text-white/70 text-xs">HTML, CSS, JS</p>
                <div className="absolute bottom-4 right-4 w-16 h-16 bg-white/10 rounded-full"></div>
              </div>
          
              {/* Card 3 - Informatics */}
              <div className="absolute bottom-0 left-1/4 w-48 h-56 bg-gradient-to-br from-blue-500 to-indigo-600 rounded-3xl shadow-2xl p-5 transform rotate-[3deg] hover:rotate-0 transition-all duration-500 hover:scale-105 cursor-pointer z-30">
                <div className="w-12 h-12 bg-white/20 rounded-xl flex items-center justify-center mb-4">
                  <Monitor className="w-6 h-6 text-white" />
                </div>
                <h4 className="text-white font-bold text-lg mb-1">İnformatika</h4>
                <p className="text-white/70 text-xs">{t.nav.courses === 'Kurslar' ? 'Qəbul hazırlığı' : 'Exam prep'}</p>
                <div className="absolute bottom-4 right-4 w-16 h-16 bg-white/10 rounded-full"></div>
              </div>
          
              {/* Decorative circles */}
              <div className="absolute -top-4 right-1/4 w-8 h-8 bg-cyan-300/50 rounded-full animate-pulse"></div>
              <div className="absolute bottom-1/4 -left-4 w-6 h-6 bg-sky-300/50 rounded-full animate-pulse delay-500"></div>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default About;
